import React, {useState, useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import { getAcademyCategory } from "../../api/Api";
import { Difficulty } from "../../shared/Difficulty";
import { useNavigate } from "react-router-dom";
import PageContainer from '../../shared/PageContainer';
import GlowCard from '../../shared/GlowCard';
import StatusBadge from '../../shared/StatusBadge';
import CyberpunkTitle from '../../shared/CyberpunkTitle';
import { useColors } from '../../theme/ColorModeContext';
import { categoryTitles, getAcademyTrackForCategory } from './skillTreeData';

interface PropsAcademy {
    token: string;
}

interface Challenge {
    id: string;
    name: string;
    difficulty: number;
    points: number;
    solved: boolean;
}

const Challenges = (props: PropsAcademy) => {
    const colors = useColors();
    const [challenges, setChallenges] = useState<Challenge[]>([]);
    const token = props.token;
    const { category } = useParams();
    const navigate = useNavigate();
    const track = getAcademyTrackForCategory(category);

    const title = categoryTitles[category || ''] || '';

    useEffect(() => {
        if(!token && (category !== "solidity" && category !== "introduction" && category !== "access-control")) {
            navigate("/register");
            return;
        }
        const fetchData = async () => {
            const data = await getAcademyCategory(token, category);
            if(data) {
                setChallenges(data.challenges);
            }
        }
        fetchData();
    }, []);

    return (
        <PageContainer>
            <CyberpunkTitle segments={[{ label: track.title, to: `/academy/${track.slug}` }, { label: title }]} mb="24px" />
            <GlowCard glowOnHover={false}>
                <TableContainer>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell align="right" sx={{ width: '50px' }}>#</TableCell>
                      <TableCell align="left">Mission</TableCell>
                      <TableCell align="right">Difficulty</TableCell>
                      <TableCell align="right">Points</TableCell>
                      <TableCell align="right">Status</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                  {challenges.map((challenge, idx) => (
                      <TableRow key={idx} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                        <TableCell align="right" sx={{ color: colors.text.muted }}>{idx + 1}</TableCell>
                        <TableCell align="left" sx={{ fontWeight: 500 }}>
                            <Link style={{ textDecoration: 'none' }} to={`/academy/challenge/${challenge.id}`}>
                                <Box sx={{ color: colors.text.primary, '&:hover': { color: colors.accent.cyan }, transition: 'color 0.2s ease' }}>
                                    {challenge.name}
                                </Box>
                            </Link>
                        </TableCell>
                        <TableCell align="right">
                            <Difficulty level={challenge.difficulty} />
                        </TableCell>
                        <TableCell align="right">{challenge.points}</TableCell>
                        <TableCell align="right">
                            <StatusBadge solved={challenge.solved} />
                        </TableCell>
                      </TableRow>
                  ))}
                  </TableBody>
                </Table>
                </TableContainer>
            </GlowCard>
            {!challenges.length && <Box sx={{ textAlign: 'center', marginTop: '40px' }}><CircularProgress size={60} /></Box>}
        </PageContainer>
    );
}

export default Challenges;
